import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.map.js";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.function.name.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import Vue from 'vue';
import Vuex from 'vuex';
import Meta from 'vue-meta';
import ClientOnly from 'vue-client-only';
import NoSsr from 'vue-no-ssr';
import { createRouter } from './router.js';
import NuxtChild from './components/nuxt-child.js';
import NuxtError from '../layouts/error.vue';
import Nuxt from './components/nuxt.js';
import App from './App.js';
import { setContext, getLocation, getRouteData, normalizeError } from './utils';
import { createStore } from './store.js';

/* Plugins */

import nuxt_plugin_vuescrollto_705c7b80 from 'nuxt_plugin_vuescrollto_705c7b80'; // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_d6113fde from 'nuxt_plugin_cookieuniversalnuxt_d6113fde'; // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_recaptcha_1ae0e458 from 'nuxt_plugin_recaptcha_1ae0e458'; // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_nuxtcustomheadersmiddleware43d6af8f_0dd95919 from 'nuxt_plugin_nuxtcustomheadersmiddleware43d6af8f_0dd95919'; // Source: ./nuxt-custom-headers.middleware.43d6af8f.js (mode: 'all')
import nuxt_plugin_apollomodule_34780535 from 'nuxt_plugin_apollomodule_34780535'; // Source: ./apollo-module.js (mode: 'all')
import nuxt_plugin_axios_77f5b269 from 'nuxt_plugin_axios_77f5b269'; // Source: ./axios.js (mode: 'all')
import nuxt_plugin_webfontloader_c513012e from 'nuxt_plugin_webfontloader_c513012e'; // Source: ./webfontloader.js (mode: 'client')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80'; // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_lazysizes_63bafee8 from 'nuxt_plugin_lazysizes_63bafee8'; // Source: ../plugins/lazysizes (mode: 'client')
import nuxt_plugin_vuecarousel_6c010c3d from 'nuxt_plugin_vuecarousel_6c010c3d'; // Source: ../plugins/vue-carousel (mode: 'client')
import nuxt_plugin_vueselect_0c6a19ce from 'nuxt_plugin_vueselect_0c6a19ce'; // Source: ../plugins/vue-select (mode: 'client')
import nuxt_plugin_smoothscroll_68d9071e from 'nuxt_plugin_smoothscroll_68d9071e'; // Source: ../plugins/smoothscroll (mode: 'client')
import nuxt_plugin_vue2touchevents_0aa7791c from 'nuxt_plugin_vue2touchevents_0aa7791c'; // Source: ../plugins/vue2-touch-events (mode: 'client')
import nuxt_plugin_routenavigation_72364ba9 from 'nuxt_plugin_routenavigation_72364ba9'; // Source: ../plugins/route-navigation.js (mode: 'client')
import nuxt_plugin_capitalize_211e3ee2 from 'nuxt_plugin_capitalize_211e3ee2'; // Source: ../plugins/capitalize (mode: 'all')
import nuxt_plugin_globalmixins_415d51c6 from 'nuxt_plugin_globalmixins_415d51c6'; // Source: ../plugins/global-mixins (mode: 'all')
import nuxt_plugin_mdmicon_d6dbc0b4 from 'nuxt_plugin_mdmicon_d6dbc0b4'; // Source: ../plugins/mdm-icon (mode: 'all')
import nuxt_plugin_vuei18n_9dc1c90a from 'nuxt_plugin_vuei18n_9dc1c90a'; // Source: ../plugins/vue-i18n (mode: 'all')
import nuxt_plugin_logplugin_7f46fc5c from 'nuxt_plugin_logplugin_7f46fc5c'; // Source: ../plugins/log-plugin (mode: 'all')
import nuxt_plugin_logenv_09c8daa4 from 'nuxt_plugin_logenv_09c8daa4'; // Source: ../plugins/log-env (mode: 'all')
import nuxt_plugin_logabtest_1cb507ff from 'nuxt_plugin_logabtest_1cb507ff'; // Source: ../plugins/log-ab-test (mode: 'all')
import nuxt_plugin_vuetooltip_f49054f4 from 'nuxt_plugin_vuetooltip_f49054f4'; // Source: ../plugins/vue-tooltip (mode: 'all')
import nuxt_plugin_featureflag_b090ab4e from 'nuxt_plugin_featureflag_b090ab4e'; // Source: ../plugins/feature-flag (mode: 'all')
import nuxt_plugin_datadome_7321f394 from 'nuxt_plugin_datadome_7321f394'; // Source: ../plugins/datadome.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly);

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, _objectSpread(_objectSpread({}, NoSsr), {}, {
  render: function render(h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true;
      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead');
    }
    return NoSsr.render(h, ctx);
  }
}));

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild);
Vue.component('NChild', NuxtChild);

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt);
Object.defineProperty(Vue.prototype, '$nuxt', {
  get: function get() {
    return this.$root.$options.$nuxt;
  },
  configurable: true
});
Vue.use(Meta, {
  "keyName": "head",
  "attribute": "data-n-head",
  "ssrAttribute": "data-n-head-ssr",
  "tagIDKeyName": "hid"
});
var defaultTransition = {
  "name": "page",
  "mode": "",
  "appear": false,
  "appearClass": "appear",
  "appearActiveClass": "appear-active",
  "appearToClass": "appear-to"
};
var originalRegisterModule = Vuex.Store.prototype.registerModule;
var baseStoreOptions = {
  preserveState: process.client
};
function registerModule(path, rawModule) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return originalRegisterModule.call(this, path, rawModule, _objectSpread(_objectSpread({}, baseStoreOptions), options));
}
function createApp(_x) {
  return _createApp.apply(this, arguments);
}
function _createApp() {
  _createApp = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(ssrContext) {
    var config,
      router,
      store,
      app,
      next,
      route,
      path,
      inject,
      _args2 = arguments;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          inject = function _inject(key, value) {
            if (!key) {
              throw new Error('inject(key, value) has no key provided');
            }
            if (value === undefined) {
              throw new Error("inject('".concat(key, "', value) has no value provided"));
            }
            key = '$' + key;
            // Add into app
            app[key] = value;
            // Add into context
            if (!app.context[key]) {
              app.context[key] = value;
            }

            // Add into store
            store[key] = app[key];

            // Check if plugin not already installed
            var installKey = '__nuxt_' + key + '_installed__';
            if (Vue[installKey]) {
              return;
            }
            Vue[installKey] = true;
            // Call Vue.use() to install the plugin into vm
            Vue.use(function () {
              if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
                Object.defineProperty(Vue.prototype, key, {
                  get: function get() {
                    return this.$root.$options[key];
                  }
                });
              }
            });
          };
          config = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
          _context2.next = 4;
          return createRouter(ssrContext);
        case 4:
          router = _context2.sent;
          store = createStore(ssrContext); // Add this.$router into store actions/mutations
          store.$router = router;

          // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
          store.registerModule = registerModule;

          // Create Root instance

          // here we inject the router and store to all child components,
          // making them available everywhere as `this.$router` and `this.$store`.
          app = _objectSpread({
            head: {
              "meta": [{
                "charset": "utf-8"
              }, {
                "name": "viewport",
                "content": "width=device-width, initial-scale=1, shrink-to-fit=no"
              }, {
                "http-equiv": "X-UA-Compatible",
                "content": "IE=edge,chrome=1"
              }, {
                "name": "p:domain_verify",
                "content": "0a86043d31b2dcce2b434e0b5f7c3339"
              }, {
                "name": "p:domain_verify",
                "content": "7158fe360cf1d00c8dcdfdeb29350a66"
              }, {
                "name": "p:domain_verify",
                "content": "770dc96158af95fed9bd7279044ad861"
              }, {
                "name": "p:domain_verify",
                "content": "c5ad649b56c6ecda0ca2c1f504119db1"
              }],
              "link": [{
                "rel": "preconnect",
                "href": "//cdn.maisonsdumonde.com"
              }, {
                "rel": "preconnect",
                "href": "//api.maisonsdumonde.com"
              }, {
                "rel": "dns-prefetch",
                "href": "//awsapis3.netreviews.eu "
              }, {
                "rel": "dns-prefetch",
                "href": "//www.maisonsdumonde.com"
              }, {
                "rel": "preconnect",
                "href": "//try.abtasty.com"
              }, {
                "rel": "dns-prefetch",
                "href": "//bam-cell.nr-data.net"
              }, {
                "rel": "preconnect",
                "href": "//fonts.googleapis.com"
              }, {
                "rel": "preconnect",
                "href": "//fonts.gstatic.com"
              }, {
                "rel": "dns-prefetch",
                "href": "//cl.avis-verifies.com"
              }, {
                "rel": "dns-prefetch",
                "href": "//track.effiliation.com"
              }, {
                "rel": "dns-prefetch",
                "href": "//nocookie.avads.net"
              }, {
                "rel": "dns-prefetch",
                "href": "//privacy.trustcommander.net"
              }, {
                "rel": "icon",
                "type": "image/x-icon",
                "href": "/favicon.ico"
              }],
              "script": [{
                "src": ["/js/externalResolverLink.js"]
              }],
              "style": []
            },
            store: store,
            router: router,
            nuxt: {
              defaultTransition: defaultTransition,
              transitions: [defaultTransition],
              setTransitions: function setTransitions(transitions) {
                if (!Array.isArray(transitions)) {
                  transitions = [transitions];
                }
                transitions = transitions.map(function (transition) {
                  if (!transition) {
                    transition = defaultTransition;
                  } else if (typeof transition === 'string') {
                    transition = Object.assign({}, defaultTransition, {
                      name: transition
                    });
                  } else {
                    transition = Object.assign({}, defaultTransition, transition);
                  }
                  return transition;
                });
                this.$options.nuxt.transitions = transitions;
                return transitions;
              },
              err: null,
              dateErr: null,
              error: function error(err) {
                err = err || null;
                app.context._errored = Boolean(err);
                err = err ? normalizeError(err) : null;
                var nuxt = app.nuxt; // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
                if (this) {
                  nuxt = this.nuxt || this.$options.nuxt;
                }
                nuxt.dateErr = Date.now();
                nuxt.err = err;
                // Used in src/server.js
                if (ssrContext) {
                  ssrContext.nuxt.error = err;
                }
                return err;
              }
            }
          }, App); // Make app available into store via this.app
          store.app = app;
          next = ssrContext ? ssrContext.next : function (location) {
            return app.router.push(location);
          }; // Resolve route
          if (ssrContext) {
            route = router.resolve(ssrContext.url).route;
          } else {
            path = getLocation(router.options.base, router.options.mode);
            route = router.resolve(path).route;
          }

          // Set context to app.context
          _context2.next = 14;
          return setContext(app, {
            store: store,
            route: route,
            next: next,
            error: app.nuxt.error.bind(app),
            payload: ssrContext ? ssrContext.payload : undefined,
            req: ssrContext ? ssrContext.req : undefined,
            res: ssrContext ? ssrContext.res : undefined,
            beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
            ssrContext: ssrContext
          });
        case 14:
          // Inject runtime config as $config
          inject('config', config);
          if (process.client) {
            // Replace store state before plugins execution
            if (window.__NUXT__ && window.__NUXT__.state) {
              store.replaceState(window.__NUXT__.state);
            }
          }

          // Add enablePreview(previewData = {}) in context for plugins
          if (process.static && process.client) {
            app.context.enablePreview = function () {
              var previewData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              app.previewData = Object.assign({}, previewData);
              inject('preview', previewData);
            };
          }
          // Plugin execution
          if (!(process.client && typeof nuxt_plugin_vuescrollto_705c7b80 === 'function')) {
            _context2.next = 20;
            break;
          }
          _context2.next = 20;
          return nuxt_plugin_vuescrollto_705c7b80(app.context, inject);
        case 20:
          if (!(typeof nuxt_plugin_cookieuniversalnuxt_d6113fde === 'function')) {
            _context2.next = 23;
            break;
          }
          _context2.next = 23;
          return nuxt_plugin_cookieuniversalnuxt_d6113fde(app.context, inject);
        case 23:
          if (!(typeof nuxt_plugin_recaptcha_1ae0e458 === 'function')) {
            _context2.next = 26;
            break;
          }
          _context2.next = 26;
          return nuxt_plugin_recaptcha_1ae0e458(app.context, inject);
        case 26:
          if (!(typeof nuxt_plugin_nuxtcustomheadersmiddleware43d6af8f_0dd95919 === 'function')) {
            _context2.next = 29;
            break;
          }
          _context2.next = 29;
          return nuxt_plugin_nuxtcustomheadersmiddleware43d6af8f_0dd95919(app.context, inject);
        case 29:
          if (!(typeof nuxt_plugin_apollomodule_34780535 === 'function')) {
            _context2.next = 32;
            break;
          }
          _context2.next = 32;
          return nuxt_plugin_apollomodule_34780535(app.context, inject);
        case 32:
          if (!(typeof nuxt_plugin_axios_77f5b269 === 'function')) {
            _context2.next = 35;
            break;
          }
          _context2.next = 35;
          return nuxt_plugin_axios_77f5b269(app.context, inject);
        case 35:
          if (!(process.client && typeof nuxt_plugin_webfontloader_c513012e === 'function')) {
            _context2.next = 38;
            break;
          }
          _context2.next = 38;
          return nuxt_plugin_webfontloader_c513012e(app.context, inject);
        case 38:
          if (!(typeof nuxt_plugin_axios_3566aa80 === 'function')) {
            _context2.next = 41;
            break;
          }
          _context2.next = 41;
          return nuxt_plugin_axios_3566aa80(app.context, inject);
        case 41:
          if (!(process.client && typeof nuxt_plugin_lazysizes_63bafee8 === 'function')) {
            _context2.next = 44;
            break;
          }
          _context2.next = 44;
          return nuxt_plugin_lazysizes_63bafee8(app.context, inject);
        case 44:
          if (!(process.client && typeof nuxt_plugin_vuecarousel_6c010c3d === 'function')) {
            _context2.next = 47;
            break;
          }
          _context2.next = 47;
          return nuxt_plugin_vuecarousel_6c010c3d(app.context, inject);
        case 47:
          if (!(process.client && typeof nuxt_plugin_vueselect_0c6a19ce === 'function')) {
            _context2.next = 50;
            break;
          }
          _context2.next = 50;
          return nuxt_plugin_vueselect_0c6a19ce(app.context, inject);
        case 50:
          if (!(process.client && typeof nuxt_plugin_smoothscroll_68d9071e === 'function')) {
            _context2.next = 53;
            break;
          }
          _context2.next = 53;
          return nuxt_plugin_smoothscroll_68d9071e(app.context, inject);
        case 53:
          if (!(process.client && typeof nuxt_plugin_vue2touchevents_0aa7791c === 'function')) {
            _context2.next = 56;
            break;
          }
          _context2.next = 56;
          return nuxt_plugin_vue2touchevents_0aa7791c(app.context, inject);
        case 56:
          if (!(process.client && typeof nuxt_plugin_routenavigation_72364ba9 === 'function')) {
            _context2.next = 59;
            break;
          }
          _context2.next = 59;
          return nuxt_plugin_routenavigation_72364ba9(app.context, inject);
        case 59:
          if (!(typeof nuxt_plugin_capitalize_211e3ee2 === 'function')) {
            _context2.next = 62;
            break;
          }
          _context2.next = 62;
          return nuxt_plugin_capitalize_211e3ee2(app.context, inject);
        case 62:
          if (!(typeof nuxt_plugin_globalmixins_415d51c6 === 'function')) {
            _context2.next = 65;
            break;
          }
          _context2.next = 65;
          return nuxt_plugin_globalmixins_415d51c6(app.context, inject);
        case 65:
          if (!(typeof nuxt_plugin_mdmicon_d6dbc0b4 === 'function')) {
            _context2.next = 68;
            break;
          }
          _context2.next = 68;
          return nuxt_plugin_mdmicon_d6dbc0b4(app.context, inject);
        case 68:
          if (!(typeof nuxt_plugin_vuei18n_9dc1c90a === 'function')) {
            _context2.next = 71;
            break;
          }
          _context2.next = 71;
          return nuxt_plugin_vuei18n_9dc1c90a(app.context, inject);
        case 71:
          if (!(typeof nuxt_plugin_logplugin_7f46fc5c === 'function')) {
            _context2.next = 74;
            break;
          }
          _context2.next = 74;
          return nuxt_plugin_logplugin_7f46fc5c(app.context, inject);
        case 74:
          if (!(typeof nuxt_plugin_logenv_09c8daa4 === 'function')) {
            _context2.next = 77;
            break;
          }
          _context2.next = 77;
          return nuxt_plugin_logenv_09c8daa4(app.context, inject);
        case 77:
          if (!(typeof nuxt_plugin_logabtest_1cb507ff === 'function')) {
            _context2.next = 80;
            break;
          }
          _context2.next = 80;
          return nuxt_plugin_logabtest_1cb507ff(app.context, inject);
        case 80:
          if (!(typeof nuxt_plugin_vuetooltip_f49054f4 === 'function')) {
            _context2.next = 83;
            break;
          }
          _context2.next = 83;
          return nuxt_plugin_vuetooltip_f49054f4(app.context, inject);
        case 83:
          if (!(typeof nuxt_plugin_featureflag_b090ab4e === 'function')) {
            _context2.next = 86;
            break;
          }
          _context2.next = 86;
          return nuxt_plugin_featureflag_b090ab4e(app.context, inject);
        case 86:
          if (!(typeof nuxt_plugin_datadome_7321f394 === 'function')) {
            _context2.next = 89;
            break;
          }
          _context2.next = 89;
          return nuxt_plugin_datadome_7321f394(app.context, inject);
        case 89:
          // Lock enablePreview in context
          if (process.static && process.client) {
            app.context.enablePreview = function () {
              console.warn('You cannot call enablePreview() outside a plugin.');
            };
          }

          // If server-side, wait for async component to be resolved first
          if (!(process.server && ssrContext && ssrContext.url)) {
            _context2.next = 93;
            break;
          }
          _context2.next = 93;
          return new Promise(function (resolve, reject) {
            router.push(ssrContext.url, resolve, function (err) {
              // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
              if (!err._isRouter) return reject(err);
              if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve();

              // navigated to a different route in router guard
              var unregister = router.afterEach( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from) {
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        ssrContext.url = to.fullPath;
                        _context.next = 3;
                        return getRouteData(to);
                      case 3:
                        app.context.route = _context.sent;
                        app.context.params = to.params || {};
                        app.context.query = to.query || {};
                        unregister();
                        resolve();
                      case 8:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x2, _x3) {
                  return _ref.apply(this, arguments);
                };
              }());
            });
          });
        case 93:
          return _context2.abrupt("return", {
            store: store,
            app: app,
            router: router
          });
        case 94:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _createApp.apply(this, arguments);
}
export { createApp, NuxtError };